<template>
    <div class="k-num-rank" :class="className"><div class="no">{{value}}</div></div>
</template>

<script>
    export default {
        name: 'k-num-rank',
        props: ['value'],
        computed: {
            className() {
                return this.value < 11 ? `k-num-rank--${this.value}` : ''
            }
        }
    };
</script>
